<template>
  <div id="app">
    <div v-if="!isMobile" class="bg avatar-list">
      <img v-for="item in imglist" v-if="item.avatar" :src="item.avatar" />
    </div>
    <modal
      height="auto"
      classes="msg-modal intro-modal"
      width="400px"
      :adaptive="true"
      name="intro"
    >
      <h4>{{$t('i18nView.appIntro')}}</h4>
      <p>{{$t('i18nView.backgroundIntro')}}</p>
      <p>{{$t('i18nView.back1')}}</p>
      <p>{{$t('i18nView.back2')}}</p>
      <p>{{$t('i18nView.rule')}}</p>
      <ul>
        <li>{{$t('i18nView.rule1')}}</li>
        <li>{{$t('i18nView.rule2')}}</li>
        <li>{{$t('i18nView.rule3')}}</li>
        <li>{{$t('i18nView.rule4')}}</li>
      </ul>
      <h4>{{$t('i18nView.supportList')}}</h4>

      <div class="support-list">
        <a target="_blank" href="https://www.tokenpocket.pro/">
          <img src="https://dapp.tokenpocket.pro/logo.jpg" alt class="dapp-icon" />
        </a>
        <a target="_blank" href="https://eospark.com/">
          <img
            src="https://gz.bcebos.com/v1/tokenpocket/dapp/eospark_new.png"
            alt
            class="dapp-icon"
          />
        </a>
        <a target="_blank" href="https://www.eosx.io/">
          <img src="https://tp-statics.cdn.bcebos.com/dapp/eosxxx.png" alt class="dapp-icon" />
        </a>
        <a target="_blank" href="https://bloks.io/">
          <img src="https://dapp.mytokenpocket.vip/dapp/bloks.png" alt class="dapp-icon" />
        </a>
        <a target="_blank" href="https://xpet.io/">
          <img
            src="https://gz.bcebos.com/v1/tokenpocket/dapp/new_version/x_pet.png"
            alt
            class="dapp-icon"
          />
        </a>
        <a target="_blank" href="https://lorefree.com/">
          <img
            src="https://tp-statics.cdn.bcebos.com/dapp/1554801261251-WeChat156c603f18cc49c2b0caa5bc75251b9b.png"
            alt
            class="dapp-icon"
          />
        </a>
        <a target="_blank" href="https://dice.one/">
          <img
            src="https://tp-statics.cdn.bcebos.com/dapp/jcJqAEKd_400x400.jpg"
            alt
            class="dapp-icon"
          />
        </a>
        <a target="_blank" href="https://big.game/">
          <img
            src="https://tp-statics.tokenpocket.pro/dapp/1562234412612-1381562234398_.pic_hd.jpg"
            alt
            class="dapp-icon"
          />
        </a>
        <a target="_blank" href="https://eossanguo.one/">
          <img
            src="https://tp-statics.tokenpocket.pro/dapp/1558496914435-93d11f820c44defbc18ca7e5264ba96.png"
            alt
            class="dapp-icon"
          />
        </a>
        <a target="_blank" href="https://eosstudio.io/">
          <img
            src="https://tp-statics.tokenpocket.pro/dapp/1563821115627-Slice.png"
            alt
            class="dapp-icon"
          />
        </a>
        <a target="_blank" href="http://eblock.io/">
          <img
            src="https://tp-statics.tokenpocket.pro/dapp/1564056526794-WechatIMG109.png"
            class="dapp-icon"
            alt
          />
        </a>
      </div>
    </modal>
    <div class="all-wrap">
      <div class="header">
        <span @click="goHome()" class="home-btn">
          <i class="iconfont icon-home"></i>
          {{$t('i18nView.home')}}
        </span>

        <span class="lang-switch">
          <a v-if="this.$i18n.locale === 'zh'" @click="changeLang('en')" href="javascript:;">En</a>
          <a v-else @click="changeLang('zh')" href="javascript:;">中</a>
        </span>

        <i @click="intro()" class="iconfont icon-info"></i>

        <span class="links">
          <a target="_blank" href="https://t.me/account_info">
            <i class="iconfont icon-telegram"></i>
          </a>
        </span>
      </div>
      <router-view />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Eos from "eosjs";
import { setTimeout } from "timers";
import { Settings } from "luxon";
import { MAIN_CONTRACT } from "./utils/constants";

export default {
  name: "metadata",
  data() {
    return {
      imglist: [],
      isMobile: true
    };
  },
  mounted() {
    this.checkLocalStorage();
  },
  created() {
    this.isMobile = !!navigator.userAgent
      .toLowerCase()
      .match(
        /(ipod|iphone|android|coolpad|tokenpocket|mmp|smartphone|midp|wap|xoom|j2me|blackberry)/i
      );

    if (!this.isMobile) {
      setTimeout(this.initBgImages, 1000);
      // this.initBgImages();
      console.log("init");
    }
  },
  methods: {
    checkLocalStorage() {
      if (!localStorage.getItem("isKnow")) {
        this.$modal.show("intro");
        localStorage.setItem("isKnow", 1);
      }
    },
    intro() {
      this.$modal.show("intro");
    },
    goHome() {
      this.$router.push("/");
    },

    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
      if (lang === "en") {
        Settings.defaultLocale = "en-US";
        document.title = "Decentralized Identity | TokenPocket";
      } else {
        Settings.defaultLocale = "zh-CN";
        document.title = "去中心化账号信息 | TokenPocket";
      }
    },
    initBgImages() {
      const network = ScatterJS.Network.fromJson({
        blockchain: "eos",
        chainId:
          "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906",
        host: "eospush.tokenpocket.pro",
        port: 443,
        protocol: "https"
      });
      var readonlyEos = Eos({
        httpEndpoint: network.protocol + "://" + network.host,
        chainId: network.chainId
      });

      var lower = "";

      var _this = this;

      function getImages() {
        readonlyEos
          .getTableRows(
            true,
            MAIN_CONTRACT,
            MAIN_CONTRACT,
            "accounts",
            "",
            lower,
            "",
            100
          )
          .then(res => {
            if (res.rows.length) {
              res.rows.forEach(item => {
                if (item.avatar) {
                  // let obj = new Image();
                  // obj.src = item.avatar;
                  // obj.onload = () => {
                  if (
                    item.avatar.indexOf(
                      "https://statics.tokenpocket.pro/avatar/"
                    ) >= 0
                  ) {
                    item.avatar += "@!avatar_40";
                  }

                  _this.imglist.push({
                    account: item.account_name,
                    title: item.title,
                    avatar: item.avatar
                  });
                  // };
                }
              });
            }
            if (res.more) {
              lower = res.rows[res.rows.length - 1].account_name;
              _this.imglist.pop();
              getImages();
            } else {
              var shuffledList = _.shuffle(_this.imglist);
              _this.imglist = shuffledList;
            }
          })
          .catch(err => {});
      }
      getImages();
    }
  }
};
</script>


<style lang="less">
@primary-color: #4e9df7;

html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #fafafa;
}

a {
  outline: none;
}

.hello,
#info,
#edit {
  background-color: #fafafa;
}

.bg {
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;

  img {
    position: relative;
    z-index: -1;
    display: inline-block;
    width: 40px;
    height: 40px;
    float: left;

    &:before {
      content: "";
      position: absolute;
      display: block;
      top: 0;
      left: 0;
      width: 40px;
      height: 40px;
      z-index: 2;
      background: rgba(255, 255, 255, 0.95);
    }
  }

  &:after {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.85);
  }
}

.dapp-icon {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  display: inline-block;
}

.all-wrap {
  box-shadow: 0 0 20px 0 #ddd;
  background-color: #fafafa;
  height: 100%;
}

.lang-switch {
  float: right;
  display: inline-block;
  font-weight: bold;
}

.lang-switch a {
  display: inline-block;
  padding: 1px 8px;
  font-size: 12px;
  text-decoration: none;
  color: @primary-color;
  border: 1px solid @primary-color;
  border-radius: 100px;
}

@media screen and (min-width: 768px) {
  .all-wrap {
    height: auto;
    padding-bottom: 40px;
  }

  .icon-exit {
    display: inline-block !important;
  }
}

@media screen and (max-width: 350px) {
  #app {
    .intro-modal {
      max-height: 300px !important;
    }
  }
}

.header {
  color: #999;
  margin: 0;
  padding: 10px 15px;
  font-size: 13px;
  background: #fafafa;

  .iconfont {
    font-size: 13px;
  }

  .icon-info {
    font-size: 18px;
    margin-right: 12px;
    padding: 0;
    float: right;
    color: @primary-color;
    cursor: pointer;
  }

  .home-btn {
    line-height: 1.5;
    display: inline-block;
    padding: 2px 8px;
    color: @primary-color;
    border: 1px solid @primary-color;
    border-radius: 4px;
    cursor: pointer;
  }

  .links {
    float: right;
    a {
      text-decoration: none;
      color: @primary-color;

      margin-right: 12px;

      .iconfont {
        font-size: 18px;
      }
    }
  }
}

#app {
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  max-width: 480px;
  margin: 0 auto;
  padding: 0;
  position: relative;
  z-index: 2;
  background-color: #fafafa;

  .invite-url {
    width: 220px;
    display: inline-block;
    margin-right: 10px;

    input {
      height: 30px;
      line-height: 30px;
    }
  }

  .intro-modal {
    border-radius: 8px;
    max-height: 500px;
    overflow: auto;

    p,
    ul,
    li {
      font-size: 13px;
      text-align: left;
    }

    ul {
      padding-left: 0;
      list-style: none;
    }
  }
}

.msg-modal {
  background: #f6f6f6;
  padding: 20px;
  box-shadow: 0 2px 10px 0 #aaaaaa;
  text-align: center;
  border-radius: 2px;

  h4 {
    margin: 10px 0;
    font-size: 16px;
  }
}
</style>
